import classNames from "classnames";
import React, { FunctionComponent, useEffect } from "react";
import { FormattedMessage } from "react-intl";
import useCartContext from "@Hooks/useCartContext";
import { DeliveryMethod, DeliveryMethodName } from "@Types/addresses";
import { convertToShippingMethod, getDeliveryMethods } from "@Utils/cart/deliveryMethods";
import { setDataLayerTrack } from "@Utils/track";
import "./style.scss";

interface Props {
  deliveryMethods: DeliveryMethod[];
  onClick: (option: DeliveryMethodName) => void;
}

export const CartDeliveryMethod: FunctionComponent<Props> = ({ deliveryMethods, onClick }) => {
  return (
    <div className="CartDeliveryMethod">
      <div className="CartDeliveryMethod-title">
        <FormattedMessage id={"cheerz_CartDeliveryMethod_title"} />
      </div>
      <div className="CartDeliveryMethod-wrapper">
        {deliveryMethods.map((option) => (
          <div
            key={option.name}
            onClick={() => onClick(option.name)}
            className={classNames("CartDeliveryMethod-choice", {
              "CartDeliveryMethod-choice--selected": option.selected,
            })}
          >
            <img src={option.logo} className="CartDeliveryMethod-choice--icon" alt="" />
            <div className="CartDeliveryMethod-choice--name">
              <FormattedMessage id={`cheerz_CartDeliveryMethod_${option.name}`} />
            </div>
            <div className="CartDeliveryMethod-choice--description">
              <FormattedMessage id={`cheerz_CartDeliveryMethod_${option.name}_description`} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

const CartDeliveryMethodContainer: FunctionComponent = () => {
  const { cart, dispatch } = useCartContext();

  useEffect(() => {
    setDataLayerTrack("Cart Shipping Methods Viewed", {
      shippingMethodsDisplayed: deliveryMethods,
    });
  }, []);

  const handleClick = (method: DeliveryMethodName) => {
    dispatch({
      method,
      type: "setShippingOptionMethod",
    });
    setDataLayerTrack("Cart Shipping Method Clicked", {
      shippingMethod: convertToShippingMethod(method),
    });
  };

  const deliveryMethods = getDeliveryMethods(cart);

  return deliveryMethods.length > 1 ? (
    <CartDeliveryMethod deliveryMethods={deliveryMethods} onClick={handleClick} />
  ) : null;
};

export default CartDeliveryMethodContainer;
